import { AppState } from "../app.state";

export const getChosenLanguage = (state: AppState) => state.i18n.chosenLanguage;
